import { ProductData } from "../../../types/ProductService/ProductService";
import { translate } from "../../Translations/translatorService";
import { persistDivorce } from "../../Persist/DivorcePersister";
import * as divorceStages from "../../Stages/StagesDivorce";
import { stageMetaDataDivorce } from "../../Stages/StagesDivorce";
import * as divorceStatus from "../../LeadStatus/StatusDivorce";
import divorceTransformations from "../FormTransformations/divorceTransformations";
import { stageFormDefinition as stageFormDefinitionDivorce } from "../FormDefinitions/divorce/stageFormDefinition";
import formDefinitionExternals from "../FormDefinitions/externals";
import { fullFormDefinition as fullFormDefinitionDivorce } from "../FormDefinitions/divorce/fullFormDefinition";
import { inquiryTypeAvailability } from "../../inquiryService";
import { placeholderPaymentTypeSwitchData } from "./productServiceFunctions";
import { Divorce } from "../../../types/Products/FamilyLaw/Divorce";

export const divorce: ProductData<Divorce> = {
  urlPart: "scheidung",
  lbUrlPart: "scheidung",
  label: translate("divorce.label"),
  generalLabel: translate("divorce.label"),
  apiUri: "divorces",
  persist: persistDivorce,
  stages: stageMetaDataDivorce,
  stageConstants: divorceStages,
  minimumCaseStatus: divorceStatus.STATUS_DATA_COMPLETED,
  minimumCaseStage: divorceStages.STAGE_INCOMPLETE,
  setBackCaseStage: divorceStages.STAGE_READY,
  paymentType: {
    insurance: "RSV",
    processCostSupport: "VKH",
    private: "Rechnung",
    installment: "Raten",
  },
  paymentTypeSwitchData: placeholderPaymentTypeSwitchData,
  courtAppointmentCreationAvailable: (product) => product.stage >= divorceStages.STAGE_SUBMITTED,
  lbProductClass: "App\\Entity\\Legalbird\\FamilyLaw\\Divorce\\Divorce",
  formTransformations: divorceTransformations,
  formDefinition: () => stageFormDefinitionDivorce(),
  formDefinitionExternals: () => formDefinitionExternals["divorce"],
  fullFormDefinition: ({ product }) => fullFormDefinitionDivorce(product),
  productSpecificDefinition: () => [],
  productCategory: "familyLaw",
  productSpecificBadges: ({}) => [],
  caseSubBarAdditionalInformation: ({}) => null,
  showCaseDescription: () => false,
  inquiryTypeAvailability: inquiryTypeAvailability.divorce,
};
